import { translations } from './translations';

export const getTranslation = () => {
  const browserLang = (navigator.language || navigator.userLanguage || '').slice(0, 2) || '';
  return translations[browserLang] || translations.en;
};
